var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.unique_mask_id = 0;

OCS.get_unique_mask_id = function() {
    OCS.unique_mask_id++;
    return OCS.unique_mask_id+"";
};

OCS.Classes.Mask = new Class({
    Implements: [Options, Events],
    options: {
        style: {'width': '100%', 'height': '100%', 'position': 'absolute', 'z-index': 9999, 'background': '#000', 'opacity': '0.7', 'top': '0'},
        'class': 'mask',
        maskMargins: false,
        id: null,
        iframeShimOptions: {},
        popup_data_name: 'mask',
        jquery_event_namespace: '.popup_mask' // The name space the event will be registered under.
    },
    initialize: function (target, options) {
        this.target = target;
        var data_name;
        if (options.popup_data_name) {
            data_name = options.popup_data_name;
        } else {
            data_name = this.options.popup_data_name;
        }

        var mask = target.data(data_name);
        if (mask) {
            return mask;
        } else {
            target.data(data_name, this);
        }
        this.setOptions(options);
        this.render();
    },
    render: function () {
        this.element = jQuery("<div>", {
            'class': this.options.class,
            'id': this.options.id || 'mask-' + OCS.get_unique_mask_id(),
            'css': jQuery.merge(this.options.style, {
                display: 'none'
            })
        });

        this.target.append(this.element);

        this.hidden = true;
    },
    toElement: function () {
        return this.element;
    },
    showMask: function () {
        this.element.css('display', 'block');
        this.element.on('mousedown'+this.options.jquery_event_namespace, this.mouse_down.bind(this));
        this.element.on('click'+this.options.jquery_event_namespace, this.click.bind(this));
        this.hidden = false;
        this.fireEvent('show');
    },
    hideMask: function () {
        this.element.off(this.options.jquery_event_namespace);
        this.element.css('display', 'none');
        this.hidden = true;
        this.fireEvent('hide');
    },
    destroy: function () {
        this.hideMask();
        this.fireEvent('destroy');
        this.element.off(this.options.jquery_event_namespace);
        this.element.remove();
    },
    mouse_down: function (e) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        this.fireEvent('mousedown');
    },
    click: function (e) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        this.fireEvent('click');
    }

});

